// extracted by mini-css-extract-plugin
export default {"main":"styles_main__s6ZWP","title":"styles_title__UgzFI","faculties":"styles_faculties__u+w5G","zoom":"styles_zoom__P3OGk","faculties-mobile":"styles_faculties-mobile__aeO8U"};